import { render } from "./DocumentosGenerados.vue?vue&type=template&id=6a42bd1c"
import script from "./DocumentosGenerados.vue?vue&type=script&lang=js"
export * from "./DocumentosGenerados.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__